<template>
  <div class="login">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Login</span>
      </heading-wrap>
      <div class="login-container text-center">
        <img alt="otomo logo" width="75" src="../assets/otomo-logo.svg">
        <div class="login-box text-center">
          <div class="form-group row">
            <field
                id="email"
                :placeholder="'Email address'"
                :type="'email'"
                :error="errors.email"
                v-model="model.email"
            />
          </div>
          <div class="form-group row">
            <div class="has-password-toggle">
              <field
                  id="password"
                  :placeholder="'Password'"
                  :error="errors.password"
                  :type="passwordVisible ? 'text' : 'password'"
                  v-model="model.password"
              />
              <div class="password-toggle" @click="showHidePassword"><i class="fa fa-eye" aria-hidden="true"></i></div>
            </div>
          </div>
          <div class="form-group row">
            <Button
                class="col-xs-12"
                :onClick="loginUIAction"
            >
              Login
              <img v-if="isLoading" alt="loading" width="15" src="../assets/loader-green-clear.gif">
            </Button>
          </div>
          <div class="form-group row">
            <div class="col-xs-6 text-left">
            <div class="checkbox">
              <input type="checkbox" id="_remember_me" name="_remember_me" v-model="model.remember">
              <label for="_remember_me">Keep me signed in</label>
            </div>
          </div>
            <div class="col-xs-6 text-right">
              <a @click.prevent="goForgotPass" href="javascript:;">Forgot your password?</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/button'
import Field from '@/components/Form/Field/field'
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import {notificationMixin} from '@/mixins/notificationMixin'
import {authMixin} from '@/mixins/authMixin'
import {profileMixin} from '@/mixins/profileMixin'

const NOTIFICATION_DELAY = 8000

export default {
  name: 'Login',
  mixins: [notificationMixin, authMixin, profileMixin],
  components: {
    Button,
    Field,
    HeadingWrap
  },
  data: () => ({
    model: {
      email: '',
      password: '',
      remember: false
    },
    passwordVisible: false,
    isLoading: false,
    errors: {
      email: '',
      password: ''
    }
  }),
  methods: {
    showHidePassword () {
      this.passwordVisible = !this.passwordVisible
    },
    loginUIAction () {
      if (this.isLoading) return false
      if (!this.isValidEmail()) return false
      if (!this.isValidPassword()) return false

      this.isLoading = true
      this.doLogin({
        username: this.model.email,
        password: this.model.password,
        remember: this.model.remember
      }).then(() => {
        this.isLoading = false
        this.getCurrentUser().then(response => {
          setInterval(() => {
            this.getCurrentUser()
          }, 2 * 60 * 1000)
          if (JSON.parse(localStorage.getItem('previousPath'))) {
            this.$router.push({ path: '/' })
            // this.$router.push({ path: JSON.parse(localStorage.getItem('previousPath')) })
          } else {
            this.$router.push({ path: '/' })
          }
        })
      }).catch(error => {
        const notification = this.addNotification('danger', error)
        this.isLoading = false
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, NOTIFICATION_DELAY) // Wait 8 seconds to remove the notification
      })
    },
    isValidEmail () {
      if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(this.model.email))) {
        this.errors.email = 'Please enter a valid email address'
        return false
      }

      this.errors.email = ''
      return true
    },
    isValidPassword () {
      if (!(/^(?!\s*$).+/.test(this.model.password))) {
        this.errors.password = 'Please enter a valid password'
        return false
      }

      this.errors.password = ''
      return true
    },
    goForgotPass () {
      this.$router.push({ name: 'ForgotPassword' })
    }
  }
}
</script>

<style lang="scss">

.login {
  .login-container{
    padding-top: 50px;
  }

  .login-box {
    max-width: 400px;
    margin: 50px auto 0;

    .help-block {
      text-align: left;
    }

    .checkbox {
      margin-bottom: unset;
      margin-left: 10px;
      margin-top: unset;
      label {
        padding-left: unset;
      }
    }
  }

  .has-password-toggle {
    position: relative;
    [type=password], [type=text] {
      padding-right: 50px;
    }

    .password-toggle {
      position: absolute;
      right: 0;
      top: 0;
      padding: 6px 12px;
      font-size: 130%;
      line-height: 1.438;
      opacity: .6;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/login.vue